import { init, RematchDispatch, RematchRootState } from '@rematch/core';
import { models, RootModel } from './models';
import { enableMapSet } from 'immer';
import persistPlugin from '@rematch/persist';
import storage from 'redux-persist/lib/storage';
import { persistStore } from 'redux-persist';

enableMapSet();

const persistConfig = {
    whitelist: ['customTokens', 'latestTokens', 'pageLayout', 'favorite', 'loginConfig', 'liquidity'],
    timeout: 100,
    key: 'root',
    storage,
};

export const store = init({
    name: 'iZUMi models',
    models,
    plugins: [persistPlugin(persistConfig) as any],
});
export const persistor = persistStore(store);
export type Store = typeof store;
export type RootDispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;
